import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ChannelMiniEntity } from '../../domain/entities/ChannelMiniEntity'
import type { ChannelLayoutAdminDto } from '@/backend/market'

export class ChannelMiniModel extends ChannelMiniEntity {
  constructor(dataDto: ChannelLayoutAdminDto) {
    super()
    mapEntityProperties<ChannelMiniModel>(this, dataDto, {
      map: {
        layouts: dataDto.channelRegion?.regionLayouts
      }
    })
  }
}
